import React, { memo, forwardRef } from 'react';
import { Row, Checkbox } from 'antd';
import renderExtra from '@modules/questionnaires/extraComponent/renderExtra';

export const SelectionWrapper = forwardRef((props, ref) => {
  const { children, options, cols, values, isLoading, attribute } = props;
  if (typeof children === 'undefined') {
    return null;
  }
  const renderElem = Array.isArray(children) ? children[0] : children;
  return (
    <Row className="selection-wrapper" gutter={16}>
      {React.cloneElement(renderElem, {
        options,
        cols,
        ref,
        values,
        isLoading,
        disabled: isLoading,
        attribute,
      })}
    </Row>
  );
});

// const Stem = ({ value }) => (
//   <>
//     <p className="stem-content">{value.content}</p>
//     {value.subContent ? (
//       <p className="stem-subcontent">{value.subContent}</p>
//     ) : null}
//   </>
// );

const Question = (props) => {
  const { children, stem, markNotApplicable, steps } = props;
  const isNotApplicable =
    steps.allStatus && steps.allStatus[steps.sequence] === 3;
  return (
    <div className="question-wrapper">
      <div className="header">
        {/* <Stem value={stem} /> */}
        <p className="stem-content">{stem.content}</p>
        <div>
          {stem.titleExtraComponentType
            ? renderExtra(stem.titleExtraComponentType)
            : null}
          <Checkbox checked={isNotApplicable} onChange={markNotApplicable}>
            Not Applicable
          </Checkbox>
        </div>
      </div>
      {stem.subContent ? (
        <p className="stem-subcontent">{stem.subContent}</p>
      ) : null}
      <div className={`body ${isNotApplicable ? 'curtain-body' : ''}`}>
        {children}
        {/*{isNotApplicable && (*/}
        {/*  <>*/}
        {/*    /!*<div className="curtain-body" />*!/*/}
        {/*    <div className="curtain-answerLater" />*/}
        {/*  </>*/}
        {/*)}*/}
      </div>
      {stem.bodyExtraComponentType
        ? renderExtra(stem.bodyExtraComponentType)
        : null}
    </div>
  );
};

export default memo(Question);
